import 'styles/PAProfile.scss'
import {Urls} from '../constants'
import { waitForElem } from "../utils/waitForElem.js";

// import { postAndRedirect } from "../utils/post-and-redirect.js";
// import moment from 'moment';
// import { loader } from "../utils/loader.js";
// import { displayDateTime } from "../utils/displayDateTime.js";

(function () {
    /* global $ */
    "use strict";

	const currentState = {
		directoryname: '',
		guid: '',
		productId: '3f815b89-088c-4e11-a162-b0c000dd0a8d',
		supplierId: 'c7bc899a-6e08-4520-a754-b0ab00b80b4f',
		bcgId: '76e7e5a5-c43c-404a-a309-b0ab00b80bea',
		urlPath: '',
		offerName: '',
		offerDiscount: '',
		offerInstructions: '',
		offerDate:''
	}

	var map_location = []
	

	async function getExternalDataItemsEndpoint() {
		const endpoint = new URL(`${window.location.protocol}//${window.location.host}/s4s/ProductDetails/GetExternalDataItemsJson`);
        endpoint.searchParams.set('productId', currentState.productId)
		endpoint.searchParams.set('supplierId', currentState.supplierId);
        endpoint.searchParams.set('bcgId', currentState.bcgId);
        endpoint.searchParams.set('criterias[Guid]', currentState.guid);

		const response = await fetch(endpoint);
		const data = await response.json();
		return data;
	}

	function ensureHttpOrHttps(url) {
		// Check if the URL starts with any protocol (http or https)
		if (!/^https?:\/\//i.test(url)) {
			// If no protocol is present, prepend https:// by default
			return 'https://' + url;
		}
		// Return the original URL if it already starts with http:// or https://
		return url;
	}

	function validateCharCount(textbox, message) {
		$('body').on('keyup', textbox, function () {
			$('.js-alert-charlimit').remove();

			if ($(this).val().length >= 1000) {
				$(textbox).after(
					`
		<div class="js-alert-charlimit validation-charlimit">
			<p>${message}</p>
		</div>
	`
				)
			}
		});
	}

	// function searchThis(url, callback) {
	function searchThis(url) {


		$.getJSON(url).done(function (data) {
				
			var title = '';
			const supplierId = data.Data.AllowedSPIds;
			
			if (supplierId.length > 0) {
				var thisSupplierId = '';
				thisSupplierId = supplierId[0];
				// Make an api call to this: GET /CatalogueProducts/GetProductsJson to get the product id, supplier id and bcg id.
			fetch('/s4s/CatalogueProducts/GetProductsJson?spId=' + thisSupplierId, {
				method: 'GET'
			})
				.then(function (response) { return response.json(); })
				.then(function (json) {

					if (json.Result.length ) {

						const thisProductId = json.Result[0].Id;
						const thisSupp = json.Result[0].SupplierId;
						const thisBCG = json.Result[0].BcgId;

						// Message button
						let messageBtn = '';
						if ($.sc.authSettings.isIndividual === true) {
							messageBtn = `<button class="js-create-info-request ppl-btn alt pcg-contrast__btn" data-prod-id="${thisProductId}" data-supp-id="${thisSupp}" data-bcg-id="${thisBCG}">Send message</button>`;
						} else (
							messageBtn = '<p>Please log in to message this provider</p>'
						)

						$('.js-message-btn').html(messageBtn);
					}


				});
			}


			


			var addedAttributes = [];

			// Loop through the attributes
			for (var k = 0; k < data.Data.Attributes.length; k++) {

				var attribute = data.Data.Attributes[k];
				var attName = attribute.Name;
				var attrValue = '';
				var attrArray = [];

				// This is for the ticks
				var attrValueTick = '';
				var attrArrayTick = [];

				// This is for listss
				var attrValueList = '';
				var attrArrayList = [];

				// This is for additional
				var attrValueAdditional = '';
				var attrArrayAdditional = [];

				// This is for TASK-lists
				var attrValueTaskList = '';
				var attrArrayTaskList = [];

		

				// Need another loop in here to loop through the attribute values
				for (var j = 0; j < attribute.Values.length; j++) {

					// Sort alphabetically

					attrArray.push(' ' + attribute.Values[j].Name + '<br>');
					attrArray.sort();
					attrValue = attrArray.join('');

					// Sort alphabetically list

					attrArrayList.push('<li>' + attribute.Values[j].Name + '</li>');
					attrArrayList.sort();
					attrValueList = attrArrayList.join('');

					// Icons
					attrArrayTaskList.push('<div class="task-item"><p>' + attribute.Values[j].Name + '</p></div>');
				//	attrArrayTaskList.push('<p><i class="fas fa-dog"></i> ' + attribute.Values[j].Name + '</p>');
					attrArrayTaskList.sort();
					attrValueTaskList = attrArrayTaskList.join('');


					// Ticks
					attrArrayTick.push('<li><i class="fa fa-check"></i> ' + attribute.Values[j].Name + '</li>');
					attrArrayTick.sort();
					attrValueTick = attrArrayTick.join('');
					
					// Additional
					attrArrayAdditional.push('<li><i class="fas fa-award"></i> ' + attribute.Values[j].Name + '</li>');
					attrArrayAdditional.sort();
					attrValueAdditional = attrArrayAdditional.join('');



					// Bind the Data
					switch (attName) {

							// case 'Sector':    
							// 	createAttributes('Sector', attrValueList)
							// break;

							case 'Global region':
								createAttributes('Global region','region', attrValueList)
							break;

							// case 'Accounting':
							// 	createAttributes('Accounting', attrValueList)
							// break;

							// case 'Financial':
							// 	createAttributes('Financial', attrValueList)
							// break;

							// case 'Legal':
							// 	createAttributes('Legal', attrValueList)
							// break;

							// case 'Marketing, PR & Communications':
							// 	createAttributes('Marketing, PR & Communications', attrValueList)
							// break;

							// case 'Business Support & Operations':
							// 	createAttributes('Business Support & Operations', attrValueList)
							// break;

							// case 'Market Access':
							// 	createAttributes('Market Access', attrValueList)
							// break;

							// case 'Compliance & Risk Management':
							// 	createAttributes('Compliance & Risk Management', attrValueList)
							// break;

							// case 'Human Resources':
							// 	createAttributes('Human Resources', attrValueList)
							// break;

							// case 'Market Research & Consultancy':
							// 	createAttributes('Market Research & Consultancy', attrValueList)
							// break;

							case 'HMTC Region: Europe':
								createAttributes('Markets: Europe','europe', attrValueList)
							break;

							case 'HMTC Region: Africa':
								createAttributes('Markets: Africa','africa',  attrValueList)
							break;

							case 'HMTC Region: Middle East & Pakistan':
								createAttributes('Markets: Middle East & Pakistan','m-e-p', attrValueList)
							break;

							case 'HMTC Region: Eastern Europe & Central Asia':
								createAttributes('Markets: Eastern Europe & Central Asia','e-e-c-a', attrValueList)
							break;

							case 'HMTC Region: Asia-Pacific':
								createAttributes('Markets: Asia-Pacific','asia-pacific', attrValueList)
							break;

							case 'HMTC Region: South Asia':
								createAttributes('Markets: South Asia','south-asia', attrValueList)
							break;

							case 'HMTC Region: Latin America & Caribbean':
								createAttributes('Markets: Latin America & Caribbean','l-a-c', attrValueList)
							break;

							case 'HMTC Region: China':
								createAttributes('Markets: China','china', attrValueList)
							break;

							case 'Service Type: Accounting':
								createAttributes('Service Type: Accounting','accounting', attrValueList)
							break;

							case 'Service Type: Compliance & Risk Management':
								createAttributes('Service Type: Compliance & Risk Management','c-r-m', attrValueList)
							break;

							case 'Service Type: Marketing, PR & Communications':
								createAttributes('Service Type: Marketing, PR & Communications','m-pr-c', attrValueList)
							break;

							case 'Service Type: Financial':
								createAttributes('Service Type: Financial','financial', attrValueList)
							break;

							case 'Service Type: Business Support & Operations':
								createAttributes('Service Type: Business Support & Operations','b-s-o', attrValueList)
							break;

							case 'Service Type: Market Access':
								createAttributes('Service Type: Market Access','market-access', attrValueList)
							break;

							case 'Service Type: Market Research & Consultancy':
								createAttributes('Service Type: Market Research & Consultancy','m-r-c', attrValueList)
							break;

							case 'Service Type: Human Resources':
								createAttributes('Service Type: Human Resources','h-r', attrValueList)
							break;

							case 'Service Type: Legal':
								createAttributes('Service Type: Legal','legal', attrValueList)
							break;

							case 'Sector specialist':
								createAttributes('Sector specialist','specialist', attrValueList)
							break;

							case 'Special Offer':
								createAttributes('Special Offer','special-offer', attrValueList)
							break;
							

					}

					
					
				}

				
			}

			if (data.Data.Standard.Name !== '' && data.Data.Standard.Name !== undefined) {

				title = data.Data.Standard.Name;
				$('.js-name').text(title);
				$('.js-breadcrumb-title').text(title);
				document.title = title + "  | DBT";
				currentState.directoryname = title;
			}


			if (data.Data['Date last modified'] !== '' && data.Data['Date last modified'] !== undefined) {

				$('.js-last-updated').html('Profile last updated: ' + data.Data['Date last modified']);
			}

			if (data.Data.Standard.Description !== '' && data.Data.Standard.Description !== 'N/A' && data.Data.Standard.Description !== null) {

				var descrip = data.Data.Standard.Description;
				$('.js-description').append('<p>' + descrip + '</p>');
			}

			if (data.Data.Standard.Postcode !== '' && data.Data.Standard.Postcode !== 'N/A' && data.Data.Standard.Postcode !== null) {
				// $('.js-dashboard-body__aside').append(`<section class="js-google-maps-container" tabindex="0"><h2 class="js-google-maps-title sr-only"></h2><iframe tabindex="0" width="100%" height="450" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" src="https://maps.google.co.uk/maps?f=q&amp;source=s_q&amp;hl=en&amp;geocode=&amp;q=${data.Data.Standard.Postcode}&amp;aq=&amp;ie=UTF8&amp;hq=&amp;hnear=${data.Data.Standard.Postcode},&amp;t=m&amp;z=14&amp;iwloc=A&amp;output=embed"></iframe></section>`)

				$('.js-dashboard-body__aside').append(`
					<section class="js-google-maps-container" tabindex="0">
						<h2 class="js-google-maps-title sr-only"></h2>
						<div id="map"></div>
					</section>
				`)
				
				if (data.Data.Standard.Name !== '' && data.Data.Standard.Name !== 'N/A') {
					// $('.js-dashboard-body__aside iframe').attr('title',`Google Map of ${data.Data.Standard.Name} ${data.Data.Standard.Postcode}`)
					// $('.js-google-maps-container').attr('aria-label',`Google Map of ${data.Data.Standard.Name} ${data.Data.Standard.Postcode}`)
					$('.js-google-maps-title').text(`Google Map of ${data.Data.Standard.Name} ${data.Data.Standard.Postcode}`)
				} else {
					// $('.js-dashboard-body__aside iframe').attr('title',`Google Map`)
					// $('.js-google-maps-container').attr('aria-label',`Google Map`)
					$('.js-google-maps-title').text(`Google Map`)
				}
			}

			if (data.Data.Standard.Name !== '' && data.Data.Standard.Name !== 'N/A' && data.Data.Standard.Name !== null) {

				title = data.Data.Standard.Name;
				$('.js-heading').text(title);
				$('.js-breadcrumb-title').text(title);
				document.title = title + "  | DBT";

			}

			// if (data.Data.Standard.Phone !== '' && data.Data.Standard.Phone !== 'N/A' &&  data.Data.Standard.Phone !== null) {

			// 	$('.js-phone').html('<a class="pcg-contrast__color-main" href="tel:' + data.Data.Standard.Phone + '"><i class="fas fa-phone"></i>' + data.Data.Standard.Phone + '</a>');
			// }

			if (data.Data.Standard.Address !== '' && data.Data.Standard.Address !== 'N/A' && data.Data.Standard.Address !== null) {

				$('.js-address').text(data.Data.Standard.Address);
			}


			if (data.Data.Standard.DetailsImageUrl !== '' && data.Data.Standard.DetailsImageUrl !== 'N/A') {

				if ( data.Data.Standard.DetailsImageUrl.indexOf('bm/App_Themes/Default/Images/blank.gif') >= 0 ||
					data.Data.Standard.DetailsImageUrl.indexOf('bm') >= 0 ) {
					$('.js-imgContainer').attr('src', '/Resources/images/default.png')
				} else {
					$('.js-imgContainer').attr('src', data.Data.Standard.DetailsImageUrl)
				}

				$('.js-imgContainer').attr('alt', title)
			}

			// if (data.Data.Standard.Email !== '' && data.Data.Standard.Email !== 'N/A' && data.Data.Standard.Email !== null) {

			// 	if (data.Data.Standard.Email === 'No@email.com') {
			// 		$('.js-email').remove();
			// 	} else {
			// 		$('.js-email').html('<a class="pcg-contrast__color-main" href="mailto:' + data.Data.Standard.Email + '"><i class="fas fa-envelope"></i>' + data.Data.Standard.Email + '</a>');
			// 	}

			// }

			if (data.Data.Standard.Website !== '' && data.Data.Standard.Website  !== 'N/A' && data.Data.Standard.Website  !== null) {

				$('.js-website').html('<a class="pcg-contrast__color-main" href="' + data.Data.Standard.Website + '"><i class="fas fa-globe"></i>' + data.Data.Standard.Website + '</a>');
			}

			// if (data.Data.CustomFieldName !== '' && data.Data.CustomFieldName  !== 'N/A') {

			// 	console.log(data.Data.CustomFieldName)

			// 	$('#codeBlockOffer').text(data.Data.CustomFieldName)

			// }

			if (data.Data.Additional['Special Offer Discount'] !== '' && data.Data.Additional['Special Offer Discount'] !== 'N/A') {
				currentState.offerDiscount = data.Data.Additional['Special Offer Discount'];
			}

			if (data.Data.Additional['Special Offer Name'] !== '' && data.Data.Additional['Special Offer Name'] !== 'N/A' && data.Data.Additional['Special Offer Name'] !== null) {
	
				currentState.offerName = data.Data.Additional['Special Offer Name'];

				$('.js-dashboard-body__aside').append('<section class="special-offer-container" aria-label="Special Deal">'+
					'<div class="special-offer-header" tabindex="0">'+
						'<i class="fas fa-star"></i> <h2> Special deal</h2>'+
					'</div>'+
					'<div class="special-offer-body pcg-contrast__bg-main">'+
						`<div class="pcg-contrast__color-main">${data.Data.Additional['Special Offer Name']}</div>`+
						'<button id="openModalBtnOffer" class="openModalBtnOffer pcg-contrast__btn">Get code</button>'+
					'</div>'+
				'</section>');

			}

			if (data.Data.Additional['Special Offer Redemption Instructions'] !== '' && data.Data.Additional['Special Offer Redemption Instructions'] !== 'N/A') {
				currentState.offerInstructions = data.Data.Additional['Special Offer Redemption Instructions'];
			}

			if (data.Data.Additional["Valid until date "] !== '' && data.Data.Additional["Valid until date "] !== 'N/A') {
				currentState.offerDate = data.Data.Additional["Valid until date "]
			}
		

			// Additional fields
			createAdditionalInfo(data.Data.Additional['"Company’s official registration number "'], '"Company’s official registration number "');

			createAdditionalInfo(data.Data.Additional['Country of incorporation of the company'], 'Country of incorporation of the company');

			createAdditionalInfo(data.Data.Additional['Country where the headquarters is located'], 'Country where the headquarters is located');

			createAdditionalInfo(data.Data.Additional['Does the company or sole trader have any experience with providing services to UK companies specifically?'], 'Does the company or sole trader have any experience with providing services to UK companies specifically?');

			createAdditionalInfo(data.Data.Additional['Does the company or sole trader provide any services free of charge? This may include special offers which are available'], 'Does the company or sole trader provide any services free of charge? This may include special offers which are available');
	
			createAdditionalInfo(data.Data.Additional['If the company has any experience working with DBT or British Embassies in Europe, please provide more details about the previous cooperation'], 'If the company has any experience working with DBT or British Embassies in Europe, please provide more details about the previous cooperation');

			createAdditionalInfo(data.Data.Additional['If the company has offices in other locations, please provide other locations'], 'If the company has offices in other locations, please provide other locations');

			createAdditionalInfo(data.Data.Additional['Key contact name'], 'Key contact name');

			//createAdditionalInfo(data.Data.Additional['Key contact’s email address'], 'Key contact’s email address');

			//createAdditionalInfo(data.Data.Additional['Key contact’s phone number'], 'Key contact’s phone number');

			createAdditionalInfo(data.Data.Additional['Key contact’s position'], 'Key contact’s position');

			//createAdditionalInfo(data.Data.Additional['Please provide details about the company\'s or sole trader\'s fee structure, hourly rates, etc. This is for internal purposes only'], 'Please provide details about the company\'s or sole trader\'s fee structure, hourly rates, etc. This is for internal purposes only');

			createAdditionalInfo(data.Data.Additional['Other'], 'Other');
			


			// Social media
			if (data.Data.Additional['Facebook'] !== '' && data.Data.Additional['Facebook']  !== null) {
				const fieldInfo = data.Data.Additional['Facebook'];
				const linkText = fieldInfo.includes('<a') ? fieldInfo.match(/<a[^>]*>(.*?)<\/a>/)[1] : fieldInfo;
				$('.js-social-media').append(`<li class="pcg-contrast__color-main"><i class="fab fa-facebook-square"></i><a class="pcg-contrast__link" href="${ensureHttpOrHttps(linkText)}" target="_blank" rel="noopener"> ` + linkText + '<span class="sr-only">(opens in a new tab)</span></a></li>').show();
			}

			if (data.Data.Additional['Twitter'] !== '' && data.Data.Additional['Twitter']  !== null) {
				const fieldInfo = data.Data.Additional['Twitter'];
				const linkText = fieldInfo.includes('<a') ? fieldInfo.match(/<a[^>]*>(.*?)<\/a>/)[1] : fieldInfo;
				$('.js-social-media').append(`<li class="pcg-contrast__color-main"><i class="fab fa-twitter-square"></i><a class="pcg-contrast__link" href="${ensureHttpOrHttps(linkText)}" target="_blank" rel="noopener"> ` + linkText + '<span class="sr-only">(opens in a new tab)</span></a></li>').show();
			}

			if (data.Data.Additional['LinkedIn'] !== '' && data.Data.Additional['LinkedIn']  !== null) {
				const fieldInfo = data.Data.Additional['LinkedIn'];
				const linkText = fieldInfo.includes('<a') ? fieldInfo.match(/<a[^>]*>(.*?)<\/a>/)[1] : fieldInfo;
				$('.js-social-media').append(`<li class="pcg-contrast__color-main"><i class="fab fa-linkedin"></i><a class="pcg-contrast__link" href="${ensureHttpOrHttps(linkText)}" target="_blank" rel="noopener"> ` +linkText + '<span class="sr-only">(opens in a new tab)</span></a></li>').show();
			}


			// Youtube
			if (data.Data.Additional['Company Video'] !== '' && data.Data.Additional['Company Video']  !== null) {
				const videoUrl = data.Data.Additional['Company Video'];
				let videoEmbed = null;
				
				// Try to match standard YouTube URL format (youtube.com/watch?v=ID)
				const standardMatch = videoUrl.match(/[?&]v=([^&]+)/);
				if (standardMatch) {
					videoEmbed = standardMatch[1];
				} else {
					// Try to match shortened YouTube URL format (youtu.be/ID)
					const shortMatch = videoUrl.match(/youtu\.be\/([^?&]+)/);
					if (shortMatch) {
						videoEmbed = shortMatch[1];
					}
				}
				
				// Only append if we successfully extracted a video ID
				if (videoEmbed) {
					$('.js-dashboard-body__aside').append(
						`<section tabindex="0" class="company-video-container pcg-contrast__color-main" aria-label="Company video">
							<h2>Company Video</h2>
							<iframe width="100%" height="315" src="https://www.youtube.com/embed/${videoEmbed}"
								title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen>
							</iframe>
						</section>`);
				}
			}

			// callback();


			if (data.Data.Additional.Latitude !== undefined && data.Data.Additional.Latitude !== null && data.Data.Additional.Longitude !== undefined && data.Data.Additional.Longitude !== null) {

                $('#map').show();

                var lat = parseFloat(data.Data.Additional.Latitude)
                var lon = parseFloat(data.Data.Additional.Longitude)

                //    console.log(lat, lon)

                map_location.push(lat)
                map_location.push(lon)

            }


			if (map_location[2] !== null && map_location[3] !== undefined) {
                // Fit to bounds
                var bounds = new google.maps.LatLngBounds();

                var map = new google.maps.Map(document.getElementById('map'), {
                    maxZoom: 17,
                    zoom: 12,
                    center: { lat: map_location[2], lng: map_location[3] },
                    scrollwheel: false,
                    mapTypeId: google.maps.MapTypeId.ROADMAP
                });

                var infowindow = new google.maps.InfoWindow();

                var marker, i;

                for (i = 0; i < map_location.length; i++) {
                    marker = new google.maps.Marker({
                        position: new google.maps.LatLng(map_location[2], map_location[3]),
                        map: map
                    });

                    google.maps.event.addListener(marker, 'click', (function (marker, i) {
                        return function () {
                            // Add a button to open Google Maps in the info window content
                            var content = '<h2>' + map_location[0] + '</h2>' +
                                '<p>' + map_location[1] + '</p>' +
                                '<div class="view-link"> <a target="_blank" jstcache="6" href="https://www.google.com/maps/search/?api=1&query=' + map_location[2] + ',' + map_location[3] + '"> <span> View on Google Maps </span> </a> </div>'

                            infowindow.setContent(content);
                            infowindow.open(map, marker);
                        }
                    })(marker, i));

                    // Fit to bounds
                    bounds.extend(new google.maps.LatLng(map_location[2], map_location[3]));
                }

                // Fit these bounds to the map
                map.fitBounds(bounds);
            }

			// Open all external links in new window
			externalLinks();


		})
		.fail(function (jqxhr) {
			if (jqxhr.status == 404) {
				$placeholder.html('<h2>There is no event with such ID</h2>');
			} else {
				$placeholder.html('<h2>Error occurred while loading event</h2>');
			}
		});


	}


	function createAdditionalInfo(field, label) {
		if (field !== '' && field  !== null && field  !== undefined) {
			$('.js-description').append('<h3>' + label + '</h3><p>' + field + '</p>');
		}
	}



   function createAttributes(title, classTitle, attributes) {
		// Clear existing content of the tile with the same title
		$(`.js-dashboard-body__tile-${classTitle}`).remove();

		// Append or create a new tile with the specified title and attributes
		$('.js-dashboard-body__main').append(
			`
			<div tabindex="0" class="dashboard-body__tile js-dashboard-body__tile-${classTitle}">
				<h2>${title}</h2>
				<ul tabindex="0" class="js-sector sector">${attributes}</ul>
			</div>
			`
		);
	}

	function externalLinks() {
		// Mark all external links to open in new window
		var links = document.querySelectorAll("a");
		Array.from(links).forEach(function(link) {
			var href = link.getAttribute("href");
			
			// Check if the link is external
			if (href && (href.indexOf('://') !== -1 || href.indexOf('//') === 0) && !href.includes(window.location.host)) {
				link.setAttribute("target", "_blank");
				link.setAttribute("rel", "noopener noreferrer");
				link.classList.add("external-link"); // Add class for styling
			}
		});
	
	}


    function createPage() {
        createDashboardHeader();
        createDashboardBody();
    }

    function createDashboardHeader() {

        $('.js-paProfile').append(
            `
			<div class="pcg-content-jumbotron pcg-contrast__bg-main">
                <div class="container">
                    <nav aria-label="Breadcrumb Menu">
                        <ul class="pcg-breadcrumbs">
                            <li class="pcg-breadcrumbs__item pcg-contrast__color-alt--after">
                                <a href="/" class="pcg-breadcrumbs__link pcg-contrast__link">Home Page</a>
                            </li>
							<li class="pcg-breadcrumbs__item pcg-contrast__color-alt--after">
                                <a href="/s4s/CustomPage/Index/${Urls.pa_search}" class="pcg-breadcrumbs__link pcg-contrast__link">Find a Provider</a>
                            </li>
                            <li class="pcg-breadcrumbs__item">
                                <span class="js-name pcg-breadcrumbs__link pcg-breadcrumbs__link--active pcg-contrast__color-alt">Details</span>
                            </li>
                        </ul>
                    </nav>


                    <div class="shortlist-notification-container js-shortlist-notification-container">
                        <div class="shortlist-notification-triangle"></div>
                        <span class="js-shortlist-notification-message shortlist-notification-message"></span> 
                    </div>

                </div>
            </div>

			<div class="container">
				<div class="dashboard-header">
					<div class="dashboard-header__welcome pcg-contrast__color-main">
						<img class="contact-image js-imgContainer" src="/Resources/images/default.png" alt=""/>
						<div>
							<h1 class="js-name"></h1>
							<p class="js-address address"></p>

							<div class="contact-details__container">
							
								<div class="js-phone"></div>
								<div class="js-email"></div>
								<div class="js-website"></div>
								
							</div>

							<div class="send-message-button-container">
								<div class="js-message-btn send-message-button"></div>
							</div>
						</div>
						<!-- <div class="js-product-reviews-summary__container ratings__container"></div> -->
					</div>
				</div>
			</div> 
            `
        )
    }

	// <div id="overlayOffer" class="overlay-offer">
	// 					<div id="modalOffer" class="modal-offer">
	// 						<button id="closeModalBtnOffer" class="close-btn-offer">&times;</button>
	// 						<p class="modal-offer-title">20% off your first order</p>
	// 						<div id="modalOfferCode" class="modal-offer-code">
	// 							<button id="copyCodeBtnOffer" class="copy-code-btn-offer"><i class="far fa-clone fa-rotate-90"></i><span id="codeBlockOffer" class="code-block-offer"></span></button>
								
	// 						</div>
							
	// 						<span id="copyMessageOffer" class="copy-message-offer"></span>
	// 						<p>Quote this code when completing your first order.<br>
	// 							Valid until 01-12-23
	// 						</p>
	// 					</div>
	// 				</div>

    function createDashboardBody(){

        $('.js-paProfile').append(
            `
			<div class="container">
                <div class="dashboard-body" id="dashboard-body">

					


                    <div class="js-dashboard-body__main dashboard-body__main">

						<div class="dashboard-body__tile">
							<h2>About this Provider</h2>
                            <div class="js-description pcg-contrast__color-main"></div>
							<ul class="social-media js-social-media pcg-contrast__bg-main" style="display: none;">
							</ul>
                        </div>
                    </div>

                    <div class="dashboard-body__aside js-dashboard-body__aside">                        
						
					</div>
                </div>

			</div>
			<!-- <div class="container alt-back">
				<div class="reviews-ratings__container" id="js-product-review-anchor"></div>
			</div> -->
            `
        );

		// <iframe tabindex="0" width="100%" height="450" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" src="https://maps.google.co.uk/maps?f=q&amp;source=s_q&amp;hl=en&amp;geocode=&amp;q=wn3+6ps&amp;aq=&amp;ie=UTF8&amp;hq=&amp;hnear=wn3+6ps,+United+Kingdom&amp;t=m&amp;z=14&amp;iwloc=A&amp;output=embed"></iframe>

		// Special offers
		// <div class="special-offer-container">
		// 	<div class="special-offer-header"><i class="fas fa-star"></i> Special deal</div>
		// 	<div class="special-offer-body"><div><strong>20% off</strong> your first order</div> 
		// 	<button id="openModalBtnOffer" class="openModalBtnOffer">Get code</button></div>
		// </div>	

    }

	async function reviewRatings(){

		const reviewRatings = await getExternalDataItemsEndpoint();

		printHeaderSummary(reviewRatings);
		printReviews(reviewRatings);
	}

	function printHeaderSummary(reviewRatings) {
		if ( reviewRatings.ExternalDataItems.length !== 0 ) {

			// Get the average score
			let overallRating = 0;
			reviewRatings.ExternalDataItems.forEach(function(rating){
				overallRating += rating.Rating
			});
			overallRating = overallRating / reviewRatings.ExternalDataItems.length;

			$('.js-product-reviews-summary__container').html(
				`
					<p class="rating"><strong>Rating ${Math.round(overallRating)}/5<br></strong> <small>from ${reviewRatings.ExternalDataItems.length} review${reviewRatings.ExternalDataItems.length === 1 ? '': 's' }</small></p>
					<a class="pcg-contrast__link" href="#js-product-review-anchor">See all reviews <i class="fas fa-chevron-right"></i></a>
				`
			)
		} 
	}

	function printReviews(reviewRatings) {
		if ( reviewRatings.ExternalDataItems.length !== 0 ) {

			// Get the average score
			let overallRating = 0;
			reviewRatings.ExternalDataItems.forEach(function(rating){
				overallRating += rating.Rating
			});
			overallRating = overallRating / reviewRatings.ExternalDataItems.length;


			$('#js-product-review-anchor').html(
				`
					<h2 tabindex="0">Reviews</h2>
					<div class="reviews__header pcg-contrast__color-main">
						<div>
							<p class="pcg-contrast__color-main" tabindex="0">
								<strong>${Math.round(overallRating)}.0</strong> from ${reviewRatings.ExternalDataItems.length} review${reviewRatings.ExternalDataItems.length === 1 ? '': 's' }
							</p>
							${createStars(Math.round(overallRating))}
						</div>
					</div>
					<ul class="js-review-receipts__container"></ul>
					<div class="reviews__header pcg-contrast__color-main reviews__header-submit">
						<div>
							${$.sc.authSettings.login === null ? 
							`	
								<button class="js-redirect-to-login pcg-contrast__btn" >Log in to submit a review</button>
							` :
							`
								${$.sc.authSettings.isIndividual === true ? 
								`<button class="js-redirect-to-form pcg-contrast__btn">Submit a review</button>` :
								``
								}
							`}
							<div class="reviews-ratings__container__reviews reviews-ratings__container__reviews-submit"></div>
						</div>
					</div>
					
				`
			);

			reviewRatings.ExternalDataItems.forEach(function(rating){
				$('.js-review-receipts__container').append(
					`
						<li class="reviews-ratings-tile pcg-contrast__bg-main" tabindex="0">
							${rating.Comment === 0 ? 
								`
								<div class="review-profile inline pcg-contrast__color-main">
									${createStars(rating.Rating)}
									<p class="pcg-contrast__color-main">Rated by: ${rating.YourName === '' ? 'Anonymous' : rating.YourName}</p>
								</div>
								`
								: 
								`
								<div class="review-profile pcg-contrast__color-main">
									${createStars(rating.Rating)}
									<p class="pcg-contrast__color-main">Reviewed by: ${rating.YourName === '' ? 'Anonymous' : rating.YourName}</p>
								</div>
								<div class="pcg-contrast__color-main">
									<p class="pcg-contrast__color-main">${rating.Comment}</p>
								</div>
								`
							}
						</li>
					`
				)

			});


		
		} else {
			$('#js-product-review-anchor').html(
				`
					<h2>Reviews</h2>
					<div class="reviews__header pcg-contrast__color-main"">
						<div>
							${$.sc.authSettings.login === null ? 
							`
								<p class="pcg-contrast__color-main">
									This provider does not have any reviews. <br>
									If you would like to rate this provider <a href="/s4s/auth?returnUrl=${`${currentState.urlPath}`}">please login to your account</a>
								</p>
							` :
							`
								${$.sc.authSettings.organisationId === 'c7bc899a-6e08-4520-a754-b0ab00b80b4f' ?
									`<p class="pcg-contrast__color-main">Be the first to review this provider</p>
									<button class="js-redirect-to-form pcg-contrast__btn">Submit a review</button>
									<div class="reviews-ratings__container__reviews"></div>`
									:
									`<p>This provider does not have any reviews</p>` 
								}

							`}
							
						</div>
					</div>

				`
			)
		}
	}

	function createStars(rating) {
		switch(rating) {
			case 1:
				return `
				<div class="star-container pcg-contrast__color-main" aria-label="1 star">
					<div class="star selected"></div>
					<div class="star"></div>
					<div class="star"></div>
					<div class="star"></div>
					<div class="star"></div>
				</div>
				`
				
			case 2:
				return `
				<div class="star-container pcg-contrast__color-main" aria-label="2 stars">
					<div class="star selected"></div>
					<div class="star selected"></div>
					<div class="star"></div>
					<div class="star"></div>
					<div class="star"></div>
				</div>
				`
			case 3:
				// console.log('3')
				return `
				<div class="star-container pcg-contrast__color-main" aria-label="3 stars">
					<div class="star selected"></div>
					<div class="star selected"></div>
					<div class="star selected"></div>
					<div class="star"></div>
					<div class="star"></div>
				</div>
				`
			case 4:
				return `
				<div class="star-container pcg-contrast__color-main" aria-label="4 stars">
					<div class="star selected"></div>
					<div class="star selected"></div>
					<div class="star selected"></div>
					<div class="star selected"></div>
					<div class="star"></div>
				</div>
				`
			case 5:
				return `
				<div class="star-container pcg-contrast__color-main" aria-label="5 stars">
					<div class="star selected"></div>
					<div class="star selected"></div>
					<div class="star selected"></div>
					<div class="star selected"></div>
					<div class="star selected"></div>
				</div>
				`
		  }
	}

	function createModel(obj, prodId, supId, bcgId) {


		let form = '';
		const fields = obj.fields;

		if (fields !== undefined) {
			fields.forEach(addToModel);
		}

		function addToModel(item) {

			if (item.type === 'textarea') {
				form +=
					`
					<div class="form-element" id="form-element">    
						<label class="pcg-contrast__color-main" for="${item.id}">${item.label}</label>
						<textarea id="${item.id}"></textarea>
						<div id="message-char-limit-container">
							<p id="message-char-limit-warning-container">
								<span>Your message is too long. Messages can not be longer than 1000 characters.</span>
								<span></span>
							</p>
							<p id="message-char-limit"><span id="message-char-limit-counter">0</span><span>/1000</span></p>
						</div>
					</div>
				`;

			} else if (item.type === 'text') {
				form +=
					`   
					<div class="form-element" id="form-element">
						<label class="pcg-contrast__color-main" for="${item.id}">${item.label}</label>
						<input type="text" id="${item.id}" />
						<div id="message-char-limit-container">
							<p id="message-char-limit-warning-container">
								<span>Your message is too long. Messages can not be longer than 1000 characters.</span>
								<span></span>
							</p>
							<p id="message-char-limit"><span id="message-char-limit-counter">0</span><span>/1000</span></p>
						</div>
					</div>
				`;
			}

		}

		const altButton = obj.buttonClassAlt !== undefined ? `<button class="${obj.buttonClassAlt} default-button small">${obj.buttonAlt}</button>` : '';

		// Create overlay
		$('body').prepend(
			`
				<div class="js-overlay" style="z-index: 10000000; text-align: center; width: 100%; height: 100%; position: fixed; background-color: rgba(0,0,0,0.6)">
					<div tabindex="0" class="model-box pcg-contrast__bg-main" role="alertdialog" aria-modal="true">
						<header>
							<div>
								<h2>${obj.modelTitle}</h2>
								<p>${obj.modelText}<p>
							</div>
							<button class="js-close-pop pcg-contrast__color-main" aria-label="Close"><i class="fas fa-times"></i></button>
						</header>
						<div>
							${form}
						</div>

						<button class="${obj.buttonClass} messages-btn pcg-contrast__btn" data-prod-id="${prodId}" data-sup-id="${supId}" data-bcg-id="${bcgId}">${obj.button}</button>
						${altButton}
					</div>
				</div>
			`
		)

		$('body').on('click', '.js-close-pop', function () {
			$('.js-overlay').remove();
		});

		$(document).on('keydown', function(event) {
			if (event.key === "Escape" || event.keyCode === 27) {
				$('.js-overlay').remove();
			}
		});

		$('.js-overlay').focus()	

	}

	function embedForm() {
		$('.reviews-ratings__container__reviews').html(
			`
			<sc-fill-form-app 
			id="app" 
			class="form-default pcg-contrast__bg-main" 
			api-base-url="/s4s/api/" 
			form-id="1" 
			form-result-id="" 
			form-section-id="" 
			answered-questions="[
				{
					&quot;QuestionId&quot;:&quot;cd7b7951-08a9-436e-9ce1-6324fc27db4f&quot;,
					&quot;TextValue&quot;:&quot;${currentState.directoryname}&quot;,
					&quot;GuidValue&quot;:null,
					&quot;BoolValue&quot;:null,
					&quot;DateValue&quot;:null,
					&quot;TechnicalData&quot;:null,
					&quot;Type&quot;:null,
					&quot;IsUsedInFormResultName&quot;:false
				},{
					&quot;QuestionId&quot;:&quot;43222480-0f80-4ed3-ad13-4863424d7a04&quot;,
					&quot;TextValue&quot;:&quot;${currentState.guid}&quot;,
					&quot;GuidValue&quot;:null,
					&quot;BoolValue&quot;:null,
					&quot;DateValue&quot;:null,
					&quot;TechnicalData&quot;:null,
					&quot;Type&quot;:null,
					&quot;IsUsedInFormResultName&quot;:false
				}
			]" 
			mode="" 
			is-temp="false" 
			finish-action="" 
			close-url="/s4s/" 
			temp-form-id="" 
			is-print-view="false" 
			is-authenticated="true" 
			sign-up-url="/s4s/SignUp" 
			is-fill-form-data="false" 
			additional-data="{}" 
			unauthorizedaccesskey=""></sc-fill-form-app>
			`
		);

		waitForElem(`.star-ratings`).then(() => {

			$('.star-ratings').each(function(){

				$(this).find('.form-radio__option').each(function(i){
					i = i +1;
					$(this).addClass('star-' + i);
					if (i===1) {
						$(this).find('label').attr('aria-label', i + ' star')
					} else {
						$(this).find('label').attr('aria-label', i + ' stars')
					}
					
				});

			});

			$('.form-navigation-btns__btn_save').hide();
			$('.form-navigation-btns__btn_finish').text('Submit review')
			$('.form-navigation-btns__btn_finish').addClass('pcg-contrast__btn')
			$('.form-navigation-btns__btn_finish').attr('role', 'submit');
			$('.form-navigation-btns__btn_finish').on('click', function() {
				var interval = setInterval(function() {
					$('.section').each(function() {
						if ($(this).text().indexOf('Thank you for submitting a rating') !== -1) {
							clearInterval(interval); // Stop checking once text is found
							// Do something here when text is found
							$(this).next().hide(); // Hides the next element after the section
							$('.js-redirect-to-form').hide();
						}
					});
				}, 100);
				
			});
			
			$('label').each(function () {
	
				if ($(this).text() === 'Your name') {
					$(this).addClass('pcg-contrast__color-main')
					$(this).next().attr('autocomplete','on')
					$(this).next().attr('name','name')
				}

				if ($(this).text() === 'Comments') {
					$(this).addClass('pcg-contrast__color-main')
				}

			});
		});


		$('body').on('click', '.star-ratings .form-radio__option', function(){

			$(this).parent().find('.form-radio__option').removeClass('selected');
			$(this).addClass('selected');
			$(this).prevAll().addClass('selected');

		});
	}

	function closeForm() {
		$('#app').remove();
	}

	function windowFocus() {
		// add all the elements inside modal which you want to make focusable
		const focusableElements =
			'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
		const modal = document.querySelector('.js-overlay'); // select the modal by its id
	
		const firstFocusableElement = modal.querySelectorAll(focusableElements)[0]; // get the first element to be focused inside the modal
		const focusableContent = modal.querySelectorAll(focusableElements);
		const lastFocusableElement = focusableContent[focusableContent.length - 1]; // get the last element to be focused inside the modal
	
		let previouslyFocusedElement;
	
		document.addEventListener('keydown', function(e) {
			let isTabPressed = e.key;
	
			if (!isTabPressed) {
				return;
			}
	
			if (e.shiftKey) { // if shift key pressed for shift + tab combination
				if (document.activeElement === firstFocusableElement) {
					lastFocusableElement.focus(); // add focus for the last focusable element
					e.preventDefault();
				}
			} else { // if tab key is pressed
				if (document.activeElement === lastFocusableElement) { // if focus has reached the last focusable element, then focus the first focusable element after pressing tab
					firstFocusableElement.focus(); // add focus for the first focusable element
					e.preventDefault();
				}
			}
		});
	
		modal.addEventListener('keydown', function(e) {
			if (e.key === 'Escape') {
				closeModal();
			}
		});
	
		// Remember the previously focused element before entering the modal
		previouslyFocusedElement = document.activeElement;
	
		// Focus the first element inside the modal
		firstFocusableElement.focus();
	
		// Function to close the modal and return focus to the previously focused element
		function closeModal() {
			modal.style.display = 'none'; // Adjust this to hide your modal
			previouslyFocusedElement.focus(); // Return focus to the previously focused element
		}
	
	}

    var Attributes = {
        init: function () {
            this.adjustDom();
            this.bindUIActions();
            this.unload();
        },

        adjustDom: function () {
            createPage();

            // Get the current URL
            var currentUrl = window.location.href;
			var parsedURL = new URL(currentUrl);
			currentState.urlPath = parsedURL.pathname + parsedURL.search;

            // Parse the URL to get its search parameters
            var searchParams = new URLSearchParams(new URL(currentUrl).search);

            // Get the value of the 'q' parameter
            var paIdFromUrl= searchParams.get("q");
			currentState.guid = paIdFromUrl;

            var url = '/s4s/EventDetails/GetEventJson/' + currentState.guid;
            // searchThis(url, reviewRatings)
            searchThis(url)


			
			waitForElem(`.special-offer-container`).then(() => {
				
				const openModalBtn = document.getElementById("openModalBtnOffer");
				
                openModalBtn.addEventListener("click", function () {
                //   overlay.style.display = "flex";
			
				  const dashboardBody = document.getElementById('dashboard-body')

				  if (document.getElementById('overlayOffer') === null) {

					// Create overlay div
					var overlay = document.createElement('div');
					overlay.id = 'overlayOffer';
					overlay.className = 'overlay-offer';
		
					// Create modal div
					var modal = document.createElement('div');
					modal.id = 'modalOffer';
					modal.className = 'modal-offer pcg-contrast__bg-main';
		
					// Create close button
					var closeButton = document.createElement('button');
					closeButton.id = 'closeModalBtnOffer';
					closeButton.className = 'close-btn-offer pcg-contrast__color-main';
					closeButton.innerHTML = '&times;';
					closeButton.addEventListener("click", function () {
						overlay.style.display = "none";
					});
		
					// Create modal title
					var title = document.createElement('p');
					title.className = 'modal-offer-title pcg-contrast__color-main';
					title.textContent = currentState.offerName;
		
					// Create modal code block
					var codeBlock = document.createElement('div');
					codeBlock.id = 'modalOfferCode';
					codeBlock.className = 'modal-offer-code pcg-contrast__bg-main pcg-contrast__color-main';
		
					// Create copy code button
					var copyCodeButton = document.createElement('button');
					copyCodeButton.id = 'copyCodeBtnOffer';
					copyCodeButton.className = 'copy-code-btn-offer pcg-contrast__btn';
		
					// Create copy code icon
					var copyCodeIcon = document.createElement('i');
					copyCodeIcon.className = 'far fa-clone fa-rotate-90';

					// Create copy message span
					// var copyMessageSpan = document.createElement('span');
					// copyMessageSpan.id = 'copyMessageOffer';
					// copyMessageSpan.className = 'copy-message-offer';
		
					// Create code block span
					var codeBlockSpan = document.createElement('span');
					codeBlockSpan.id = 'codeBlockOffer';
					codeBlockSpan.className = 'code-block-offer pcg-contrast__color-main';
					codeBlockSpan.textContent = currentState.offerDiscount;
					codeBlockSpan.addEventListener("click", function () {
						const codeToCopy = codeBlockSpan.innerText;
						navigator.clipboard.writeText(codeToCopy).then(function () {
							modalOfferCode.innerHTML = "Code copied!";
						});
					});
				
					// Create modal text
					var modalTextInstruction = document.createElement('p');
					modalTextInstruction.textContent = currentState.offerInstructions;
					modalTextInstruction.className = "pcg-contrast__color-main"
					var modalTextDate = document.createElement('p');
					modalTextDate.textContent = 'Valid until ' + currentState.offerDate;
					modalTextDate.className = "pcg-contrast__color-main"
		
					// Append elements to modal
					codeBlock.appendChild(copyCodeButton);
					copyCodeButton.appendChild(copyCodeIcon);
					copyCodeButton.appendChild(codeBlockSpan);
					modal.appendChild(closeButton);
					modal.appendChild(title);
					modal.appendChild(codeBlock);
					// modal.appendChild(copyMessageSpan);
					modal.appendChild(modalTextInstruction);
					modal.appendChild(modalTextDate);

		
					// Append modal to overlay
					overlay.appendChild(modal);
		
					// Append overlay to the body
					dashboardBody.appendChild(overlay);				

				  } else {
					const overlay = document.getElementById('overlayOffer')
					overlay.style.display = "flex";
				  }

                }); 
				
			});


			

			

        },

        bindUIActions: function () {


			$('body').on('click', '.js-create-info-request', function () {

				const prodId = $(this).attr('data-prod-id');
				const supId = $(this).attr('data-supp-id');
				const bcgId = $(this).attr('data-bcg-id');

				var formBuilder = {
					button: "Send message",
					buttonClass: "js-create-info-request-send",
					// buttonAlt: "No",
					// buttonClassAlt: "js-return-btn",
					modelTitle: "Create your message",
					modelText: "Start your conversation by entering your message below",
					fields: [
						{
							type: 'textarea',
							label: 'My question',
							id: 'RequestText',
							maxLength: 1000,
						}
					]
				};

				

				

				createModel(formBuilder, prodId, supId, bcgId);
				document.getElementById('RequestText').addEventListener('input', function() {
					const charLimitParentContainer = document.getElementById('form-element');
					const charLimitContainer = document.getElementById('message-char-limit-counter');
					charLimitContainer.textContent = this.value.length;
					var textarea = document.getElementById('RequestText');
					textarea.scrollTop = textarea.scrollHeight;
	
					// Char limit
					if (this.value.length >= 1000) {
						charLimitParentContainer.classList.add('limit-exceeded');
						$('.js-create-info-request-send').attr('disabled','disabled')
						$('.js-create-info-request-send').addClass('disabled-btn')
					} else {
						charLimitParentContainer.classList.remove('limit-exceeded');
						$('.js-create-info-request-send').removeAttr('disabled');
						$('.js-create-info-request-send').removeClass('disabled-btn');
					}
								
				});

				// validateCharCount('#RequestText', 'Your message is over 1000 characters – please shorten your message. Remember, this message is just to start the conversation and you can send more messages in your ‘My Messages’ page.');
				// validateCharCount('.js-thisMessage', 'Your message is over 1000 characters – please shorten your message. Remember, you can send multiple messages instead of one long message.');
				windowFocus();

				$('.js-create-info-request-send').on("keydown", function(event) {
					if (event.key === "Enter") {
						$(this).click();
					}
				});
			});


			$('body').on('click', '.js-create-info-request-send', function () {
				const prodId = $(this).attr('data-prod-id');
				const supId = $(this).attr('data-sup-id');
				const bcgId = $(this).attr('data-bcg-id');

				var textbox = $('#RequestText').val();
				var formData = 'productId=' + prodId + '&supplierId=' + supId + '&bcgId=' + bcgId + '&textOfInformationRequest=' + textbox + '&IsFaceToFaceMeeting=true';

				$('.js-overlay ').html(`
					<div class="visually-hidden" role="status">Loading...</div>
					<div class="loader">
						<div class="square" id="sq1"></div>
						<div class="square" id="sq2"></div>
						<div class="square" id="sq3"></div>
						<div class="square" id="sq4"></div>
						<div class="square" id="sq5"></div>
						<div class="square" id="sq6"></div>
						<div class="square" id="sq7"></div>
						<div class="square" id="sq8"></div>
						<div class="square" id="sq9"></div>
					</div>
				`);

				// Prevent user from clicking on button multiple times
				$('body').prepend(
					'<div class="js-overlay tint10 block" style="width: 100%; height: 100%; z-index: 1000000; position: fixed"></div>'
				);


				$.ajax({
					url: '/s4s/ProductDetails/SubmitInformationRequestJS',
					type: 'POST',
					data: formData,
					contentType: 'application/x-www-form-urlencoded;charset=UTF-8',
					success: function (data, textStatus, jqXHR) {
						//data - response from server

						if (jqXHR.status === 302 || jqXHR.status === 200) {

							//$('body').append('<div class="js-request-notification bottom-notification section pad20">Your Information request has been sent. You can track its progress in "<a href="/s4s/MyOrders/InformationRequestsTab">My queries/ quotes</a>"</div>');
							$('.js-overlay ').html(
								`  <div tabindex="0" class="model-box pcg-contrast__bg-main" role="status">
										<header>
											<div>
												<h2>Message sent!</h2>
											</div>
											<button class="js-close-pop pcg-contrast__color-main" aria-label="Close"><i class="fas fa-times"></i></button>
										</header>
										<div>
											<p class="pcg-contrast__color-main">Your message has been sent.
										</div>
									</div>

								`
							)

							// $('.model-box').attr('role', 'status');

							setTimeout(function () {
								$('.js-request-notification').fadeOut('slow', function () {
									$('.js-request-notification').remove();
								});

								$('.js-overlay').remove();
								$('.js-request-info-pop').hide();

							}, 10000);
						}

					},
					error: function (jqXHR, textStatus, errorThrown) {
						$('.js-overlay').remove();
						$('.js-request-info-pop').hide();

						$('body').append('<div class="js-request-notification bottom-notification section pad20 pcg-contrast__color-main">We have been unable to send your information request at this time. Please try again and if you have further problems please contact us.</div>');

						setTimeout(function () {
							$('.js-request-notification').fadeOut('slow', function () {
								$('.js-request-notification').remove();
							});

						}, 10000);
					}
				});

			});


			// $('body').on('click', '.js-redirect-to-form', function(e){
            //     e.preventDefault();
            //     postAndRedirect("/s4s/FormDetails/FillForm?formId=1", [
            //         { questionId: 'cd7b7951-08a9-436e-9ce1-6324fc27db4f', answerText: currentState.directoryname },
            //         { questionId: '43222480-0f80-4ed3-ad13-4863424d7a04', answerText: currentState.guid }
            //     ]);
            // });

			$('body').on('click', '.js-redirect-to-form', function(e){
                // e.preventDefault();
                // postAndRedirect("/s4s/FormDetails/FillForm?formId=1", [
                //     { questionId: 'cd7b7951-08a9-436e-9ce1-6324fc27db4f', answerText: currentState.directoryname },
                //     { questionId: '43222480-0f80-4ed3-ad13-4863424d7a04', answerText: currentState.guid }
                // ]);
				if ( $(this).hasClass('selected') ) {
					closeForm();
					$(this).removeClass('selected').text('Submit a review');
				} else {
					embedForm();
					$(this).addClass('selected').text('Cancel review')
				}
            });

			$('body').on('click', '.js-redirect-to-login', function(e){
				window.location.href = `/s4s/auth?returnUrl=${currentState.urlPath}`;
            });

			// Add focus on Rating
			$(document).keydown(function (e) {
				if (e.keyCode === 9) { // Check for Tab key press
					setTimeout(() => {
						let focusedElement = document.activeElement;
						// console.log(focusedElement)
						let starInput = $('.star-ratings .star-1 input');
						if ($(focusedElement).is(starInput)) {
							$(focusedElement).closest('fieldset').addClass('alt-focus');
						} else {
							$(starInput).closest('fieldset').removeClass('alt-focus');
						}

					}, 200);
				}
			});
			

        },

        unload: function () {},
    };

    Attributes.init();
})();